import type { TypographyTheme } from '@smiledragon-corp/sds-system';

const typoSizePx = {
  body: '16px',
  body2: '14px',
  caption: '12px',
  caption2: '10px',
  header: '24px',
  header2: '20px',
  header3: '18px',
  title: '40px',
  title2: '32px',
  title3: '28px',
};

export const typography: TypographyTheme = {
  body: {
    bold: {
      fontSize: typoSizePx.body,
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '22px',
    },
    medium: {
      fontSize: typoSizePx.body,
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '22px',
    },
    regular: {
      fontSize: typoSizePx.body,
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '22px',
    },
  },
  body2: {
    bold: {
      fontSize: typoSizePx.body2,
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '20px',
    },
    medium: {
      fontSize: typoSizePx.body2,
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '20px',
    },
    regular: {
      fontSize: typoSizePx.body2,
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '20px',
    },
  },
  caption: {
    bold: {
      fontSize: typoSizePx.caption,
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '18px',
    },
    medium: {
      fontSize: typoSizePx.caption,
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '18px',
    },
    regular: {
      fontSize: typoSizePx.caption,
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '18px',
    },
  },
  caption2: {
    bold: {
      fontSize: typoSizePx.caption,
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '16px',
    },
    medium: {
      fontSize: typoSizePx.caption,
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '16px',
    },
    regular: {
      fontSize: typoSizePx.caption,
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '16px',
    },
  },
  header: {
    bold: {
      fontSize: typoSizePx.header,
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '34px',
    },
    medium: {
      fontSize: typoSizePx.header,
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '34px',
    },
    regular: {
      fontSize: typoSizePx.header,
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '34px',
    },
  },
  header2: {
    bold: {
      fontSize: typoSizePx.header2,
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '28px',
    },
    medium: {
      fontSize: typoSizePx.header2,
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '28px',
    },
    regular: {
      fontSize: typoSizePx.header2,
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '28px',
    },
  },
  header3: {
    bold: {
      fontSize: typoSizePx.header3,
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '24px',
    },
    medium: {
      fontSize: typoSizePx.header3,
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '24px',
    },
    regular: {
      fontSize: typoSizePx.header3,
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '24px',
    },
  },
  title: {
    bold: {
      fontSize: typoSizePx.title,
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '52px',
    },
    medium: {
      fontSize: typoSizePx.title,
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '52px',
    },
    regular: {
      fontSize: typoSizePx.title,
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '52px',
    },
  },
  title2: {
    bold: {
      fontSize: typoSizePx.title2,
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '42px',
    },
    medium: {
      fontSize: typoSizePx.title2,
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '42px',
    },
    regular: {
      fontSize: typoSizePx.title2,
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '42px',
    },
  },
  title3: {
    bold: {
      fontSize: typoSizePx.title3,
      fontWeight: '700',
      letterSpacing: '-0.0125em',
      lineHeight: '38px',
    },
    medium: {
      fontSize: typoSizePx.title3,
      fontWeight: '500',
      letterSpacing: '-0.0125em',
      lineHeight: '38px',
    },
    regular: {
      fontSize: typoSizePx.title3,
      fontWeight: '400',
      letterSpacing: '-0.0125em',
      lineHeight: '38px',
    },
  },
};
